<div class="row">
    <div class="col-12 col-lg-4 mb-3">
        <label class="app__label">
            Left return corners
        </label>
    </div>
    <div class="col-12 col-lg-4 mb-3">
        <input
        (focus)="triggerSetSubStep('leftReturnCorner')"
        (blur)="triggerClearSubStep()"
        type="number"
        class="form-control"
        [(ngModel)]="product.cornersLR"
        (ngModelChange)="calcBespokeCost()" />

    </div>
</div>

<div class="row">
    <div class="col-12 col-lg-4 mb-3">
        <label class="app__label">
            Right return corners
        </label>
    </div>
    <div class="col-12 col-lg-4 mb-3">
        <input
        (focus)="triggerSetSubStep('rightReturnCorner')"
        (blur)="triggerClearSubStep()"
        type="number"
        class="form-control"
        [(ngModel)]="product.cornersRR"
        (ngModelChange)="calcBespokeCost()" />

    </div>
</div>

<div class="row">
    <div class="col-12 col-lg-4 mb-3">
        <label class="app__label">
            End pieces
        </label>
    </div>
    <div class="col-12 col-lg-4 mb-3">
        <input
        (focus)="triggerSetSubStep('endPiece')"
        (blur)="triggerClearSubStep()"
        type="number"
        class="form-control"
        [(ngModel)]="product.ends"
        (ngModelChange)="calcBespokeCost()" />
    </div>
</div>


